import React, { useState } from "react";
import "../../assets/css/advertising.css";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { Button, Tabs, Tab, Box, Stack, AlertTitle } from "@mui/material";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import config from "../../api/config";
import { setToast } from "../../redux/actions/ToastAction";
import Alert from "../alert";
import { markdownToHtml } from "../TextEditor/Parser";

// tabs
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const CPost = () => {
  const { location } = useHistory();
  const data = location.data;
  const navigate = useHistory();
  const dispatch = useDispatch();
  // tabs
  const [value, setValue] = useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const Confirm = async () => {
    try {
      const res = await config.post(`/api/moderator/v1/post/${data?.id}`);
      // dispatch(setToast("true", "success", "Успешно опубликовано"));
      dispatch(setToast(true, "info", res.data?.message));
      navigate.push("/");
    } catch (err) {
      console.error(err?.message);
    }
  };
  return (
    <div className="advertising">
      <div className="d-flex align-items-center justify-content-between">
        <Button
          onClick={() => navigate.push(`/`)}
          variant="outlined"
          startIcon={<ArrowBackIosNewIcon />}
          style={{
            padding: "12px 22px",
            borderRadius: "40px",
            fontWeight: "bold",
          }}
        >
          Отменить и назад
        </Button>
        <Stack direction="row" spacing={2}>
          <Button
            variant="outlined"
            style={{
              padding: "8px 18px",
              borderRadius: "40px",
            }}
            onClick={() =>
              navigate.push({
                pathname: `/post_ad`,
                data: data,
              })
            }
          >
            Изменить
          </Button>
          <Button
            variant="contained"
            style={{
              background: "var(--main-color)",
              fontWeight: "bold",
              padding: "12px 22px",
              borderRadius: "40px",
            }}
            onClick={Confirm}
          >
            {data?.isSent ? "Опубликовать снова" : "Подтвердить"}
          </Button>
        </Stack>
      </div>
      <br />
      <p style={{ color: "var(--second-color)" }}>Название: </p>
      <h2>{data?.name}</h2> <br />
      <p style={{ color: "var(--second-color)" }}>Категория: </p>
      <h2>{data?.c}</h2> <br />
      <p style={{ color: "var(--second-color)" }}>Автор: </p>
      <h4>
        {data.user?.firstName} {data.user?.lastName}
      </h4>{" "}
      <br />
      <p style={{ color: "var(--second-color)" }}>Статус: </p>
      <Alert severity={data?.isSent ? "success" : "error"} className="my-3">
        <AlertTitle>
          {data?.isSent ? "Подтверждено" : "Не подтверждено"}
        </AlertTitle>
      </Alert>{" "}
      <br />
      <label htmlFor="description">Полное описание</label> <br />
      <Box>
        <Box>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            <Tab
              label="Oписание Ru"
              style={{ color: "var(--txt-white)" }}
              {...a11yProps(0)}
            />
            <Tab
              label="Oписание Uz"
              style={{ color: "var(--txt-white)" }}
              {...a11yProps(1)}
            />
            <Tab
              label="Oписание En"
              style={{ color: "var(--txt-white)" }}
              {...a11yProps(2)}
            />
          </Tabs>
        </Box>
        <br />
        <TabPanel className="p-3" value={value} index={0}>
          <p>{markdownToHtml(data?.descriptionRu)}</p>
        </TabPanel>
        <TabPanel className="p-3" value={value} index={1}>
          <p> {markdownToHtml(data?.descriptionUz)} </p>
        </TabPanel>
        <TabPanel className="p-3" value={value} index={2}>
          <p> {markdownToHtml(data?.descriptionEn)} </p>
        </TabPanel>
      </Box>
    </div>
  );
};

export default CPost;
